import React from "react";
import { Button, Divider, Grid, IconButton, Typography } from "@mui/material/";
import { Close } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";
import { strings } from "../../../../common/i18n";
import { SuccessThemeProvider } from "../../../../common/styles/providers";
import AssetDetail from "../AssetDetail";
import Paper from "../Paper";
import AuxDetail from "./AuxDetail";
import styles from "./styles";

type Props = {
    isMatchAccepted: boolean,
    isResolved: boolean,
    onAccept: Function,
    onCancel: Function,
    onClose: Function,
    value: any
};

/**
 * Asset Match Component
 */
export default ({
    isMatchAccepted,
    isResolved,
    onAccept,
    onCancel,
    onClose,
    value
}: Props) => {
    const classes = makeStyles(styles)();

    return (
        <Paper
            HeaderComponent={
                <>
                    <Grid alignItems="center" container direction="row">
                        <Typography gutterBottom variant="h5">
                            {strings("matchedAsset")}
                        </Typography>
                        <div className={classes.flexGrow} />
                        <IconButton onClick={onClose} size="small">
                            <Close />
                        </IconButton>
                    </Grid>
                    <Divider />
                </>
            }
            BodyComponent={
                <>
                    <div className={classes.spacer} />
                    <AssetDetail
                        asset={value.asset}
                        attributes={value.attributes}
                    />
                    <div className={classes.spacer} />
                    <AuxDetail {...value.auxiliary} />
                </>
            }
            FooterComponent={
                isResolved ? (
                    <>
                        <Divider />
                        <div className={classes.spacer} />
                        <Typography align="center" variant="h6">
                            {strings(
                                isMatchAccepted ? "matchAccepted" : "rejected"
                            )}
                        </Typography>
                    </>
                ) : (
                    <>
                        <div className={classes.buttonContainer}>
                            <Button
                                className={classes.buttonStyle}
                                color="error"
                                onClick={onCancel}
                                size="small"
                                variant="outlined"
                            >
                                {strings("cancelMatch")}
                            </Button>
                            <SuccessThemeProvider>
                                <Button
                                    className={classes.buttonStyle}
                                    color="primary"
                                    onClick={onAccept}
                                    size="small"
                                    variant="contained"
                                >
                                    {strings("acceptMatch")}
                                </Button>
                            </SuccessThemeProvider>
                        </div>
                    </>
                )
            }
        />
    );
};
